import { request } from 'shared/lib/request';

export const voteNetPromoterScore = ({ data, id }) => {
  request.post(`/nps/${id}`, data);
};
